import React from "react";
import { SEO, CustomerMain, AdminLayout } from "../../../components";

const CustomerMainPage = () => {
  return (
    <>
      <SEO title="Customers" />
      <AdminLayout>
        <CustomerMain />
      </AdminLayout>
    </>
  );
};

export default CustomerMainPage;
